
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[permlink]",
      function () {
        return require("private-next-pages/blog/[permlink].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[permlink]"])
      });
    }
  